module.exports = __webpack_public_path__ + "img/Bottom.1b545ceb.jpg";